import { defineMessages } from 'react-intl';

const trns = defineMessages({
  toListButton: {
    id: 'TfLCGY',
    defaultMessage: 'У список товарів'
  },
  loadMore: {
    id: '5JSkv+',
    defaultMessage: 'Завантажити ще'
  },
  loadNext: {
    id: '/zArHk',
    defaultMessage: 'Завантажити наступні'
  },
  toMain: {
    id: 'HAXLH+',
    defaultMessage: 'На головну'
  }
});

export default trns;
